export enum NotificationType {
  QuestSuccess = "QuestSuccess",
  QuestError = "QuestError",
  Profession = "Profession",
  Skill = "Skill",
  PlayerLevel = "PlayerLevel",
}
